module.exports = __webpack_public_path__ + "static/media/space_spacecraft.c33afcf1.svg";